import { Box } from "@mui/material";
import LogoAt1 from "../../../assets/img/Logo/Logo.png";
import LogoAt2 from "../../../assets/img/Logo/Logo@2x.png";

export default function Logo() {
  return (
    <Box
      sx={(theme) => ({
        height: "68px",
        background: "#fff",
        px: theme.spacing(2),
        py: theme.spacing(0.5),
      })}
    >
      <picture>
        <source
          media="(min-width: 650px)"
          srcSet={`${LogoAt1} 1x, ${LogoAt2} 2x`}
        />
        <source
          media="(min-width: 465px)"
          srcSet={`${LogoAt1} 1x, ${LogoAt2} 2x`}
        />
        <img
          src={LogoAt1}
          alt="MAEP"
          style={{ width: "auto", height: "100%" }}
        />
      </picture>
    </Box>
  );
}
